import { computed } from 'vue';
import type { NuxtLinkProps } from 'nuxt/app';

export type WowPoloMenuChild = {
  label: string;
  to: string;
  // Opens in a new tab via a plain anchor rather than NuxtLink. Used for forms hosted
  // off-site, where losing the site mid-signature would be worse than a new tab.
  external?: boolean;
};

export type WowPoloMenuItem = {
  label: string;
  // Omitted for items that exist only to open a dropdown, with no page of their own.
  to?: NuxtLinkProps['to'];
  shouldRender: boolean;
  children?: WowPoloMenuChild[];
};

// Signable waiver documents hosted on JotForm. Kept here rather than inline in the nav
// so the URLs can be swapped in one place if the forms are reissued.
//
// Which form is which is not derivable from the URL, so confirm the pairing with the
// form owner before changing either of these - an adult signing the minor form, or the
// reverse, is a compliance problem rather than a cosmetic one. Current pair supplied by
// Michael Foster on 2026-08-06, adult first.
export const WOW_POLO_WAIVERS: WowPoloMenuChild[] = [
  {
    label: 'Adult Waiver',
    to: 'https://www.jotform.com/sign/250067217957058/invite/01jh1gbmksd96895b44dea55f1',
    external: true,
  },
  {
    label: 'Minor Waiver',
    to: 'https://www.jotform.com/sign/250067086390053/invite/01jh1gatrs5f43c11cf91f0953',
    external: true,
  },
];

export const useWowPoloNavigation = () => {
  const menuItems = computed<WowPoloMenuItem[]>(() => [
    {
      label: 'Home',
      to: '/',
      shouldRender: true,
    },
    {
      label: 'Tournaments',
      to: '/tournaments',
      shouldRender: true,
    },
    {
      label: 'Gallery',
      to: '/gallery',
      shouldRender: true,
      children: [],
    },
    {
      label: 'Our Partners',
      to: '/partners',
      shouldRender: true,
    },
    {
      label: 'WOWGivesBack',
      to: '/wow-polo-gives-back',
      shouldRender: true,
    },
    {
      label: 'Waivers',
      shouldRender: true,
      children: WOW_POLO_WAIVERS,
    },
    {
      label: 'Contact Us',
      to: '/contact',
      shouldRender: true,
    },
  ]);

  const visibleItems = computed(() => {
    return menuItems.value.filter((item) => item.shouldRender);
  });

  return {
    menuItems,
    visibleItems,
  };
};
